import React, { Component } from 'react';

import CalloutSection from '../Components/CalloutSection'
import Centered from "../Components/Centered";
import TextSection from "../Components/TextSection";
import TopContent from "../Components/TopContent";
import TitleText from "../Components/TitleText";
import LimitedWidthSection from "../Components/LimitedWidthSection";
import ParagraphText from "../Components/ParagraphText";

class Page extends Component {
  render() {
    return (
      <Centered>
        <TopContent>
          <CalloutSection>
            <Centered>
              <div className="spacer-40px" />
              <TitleText>Frequently Asked Questions</TitleText>
              <div className="spacer-20px" />
              <TextSection>
                <Centered>
                  <div className="spacer-20px" />
                  <LimitedWidthSection>
                    <h1>Frequently Asked Questions</h1>
                    <ParagraphText bold>What forms of payment can I use to fund the gift?</ParagraphText>
                    <ParagraphText>
                      Currently Biterica only allows Bitcoin (BTC) for funding gifts.  In the future we may extend support for other cryptocurrencies and various forms of payment.
                    </ParagraphText>
                    <br />

                    <ParagraphText bold>How fast does the money gift get delivered?</ParagraphText>
                    <ParagraphText>
                      Instantly!  Confirmation emails to sender and gift email for recipient are typically delivered within 30 seconds or less from time of funding.
                    </ParagraphText>
                    <br />

                    <ParagraphText bold>How much do you charge for your service?</ParagraphText>
                    <ParagraphText>
                      $0 as in zero.  Biterica’s free to use and does not charge any fees at this time.
                    </ParagraphText>
                    <br />

                    <ParagraphText bold>Do you support delayed delivery, ex: Birthday, etc?</ParagraphText>
                    <ParagraphText>
                      Not today.  We may support this in the future.  Luckily, it only takes a minute to send a gift with Biterica so you can send it on the day of the event without hassle.
                    </ParagraphText>
                    <br />

                    <ParagraphText bold>How do you keep accounts secure?</ParagraphText>
                    <ParagraphText>
                      We rely on our experienced partners such as Blockchain.com and Coinbase to keep accounts secure.  We do not store passwords on our servers!
                    </ParagraphText>
                    <br />

                    <ParagraphText bold>Help! I’m having trouble!</ParagraphText>
                    <ParagraphText>
                      Contact&nbsp;<a href="mailto:support@biterica.com?Subject=Biterica%20support" target="_top">support@biterica.com</a>&nbsp;with your issue and let’s get to the bottom of it.
                    </ParagraphText>
                    <br />
                    <br />
                  </LimitedWidthSection>
                  <div className="spacer-40px" />
                </Centered>
              </TextSection>
            </Centered>
          </CalloutSection>
        </TopContent>
      </Centered>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/Pages/FAQPage.js